import { Component, ElementRef, Input, Optional, Renderer2, Self, HostBinding, ChangeDetectorRef } from "@angular/core";
import { NgControl } from "@angular/forms";
import { SpsFormControlComponent } from "../forms/sps-form-control.abstract.component";
import { castToNumber } from "@spscommerce/utils";

@Component({
    selector: "sps-incrementor",
    templateUrl: "./sps-incrementor.component.html",
    providers: [{ provide: SpsFormControlComponent, useExisting: SpsIncrementorComponent }]
})
export class SpsIncrementorComponent extends SpsFormControlComponent<number> {
    static readonly displayName = "sps-incrementor";
    static readonly props = {
        min: "number",
        max: "number",
        step: "number",
    };

    @Input() @castToNumber() min = 0;
    @Input() @castToNumber() max = Number.POSITIVE_INFINITY;
    @Input() @castToNumber() step = 1;
    @Input("aria-label") ariaLabel: string;

    @HostBinding("class.sps-incrementor") readonly _spsIncrementorClass = true;
    @HostBinding("class.sps-input-group") readonly _spsInputGroupClass = true;
    @HostBinding("class.sps-input-group__append") readonly _spsInputGroupAppendClass = true;

    get value(): number {
        return this.model || 0;
    }
    set value(newValue: number) {
        this.model = Math.min(this.max, Math.max(this.min, +newValue));
    }

    constructor(
        el: ElementRef,
        renderer: Renderer2,
        @Self()
        @Optional()
        ngControl: NgControl,
        protected _changeDetector: ChangeDetectorRef,
    ) {
        super(el, renderer, ngControl);
    }

    increment() {
        this.value += this.step;
    }

    decrement() {
        this.value -= this.step;
    }

    onInputKeyDown(event) {
        if (Number.isNaN(+event.key)) {
            event.preventDefault();
        }
    }
}
